export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Share-Gray-a3550386888ff96749169b3330a4f06b.svg";